import { createApi } from '@reduxjs/toolkit/query/react';
import { TClaimedCharacterLoadoutsResponse } from '../../../../../../shared/types/characterTypes';
import { networkBaseQuery } from './utils';

export const charactersApi = createApi({
  reducerPath: 'charactersApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    claimedCharacterLoadouts: builder.query<TClaimedCharacterLoadoutsResponse, void>({
      query: () => ({ url: '/api/characters/claimed-loadouts' })
    })
  })
});

export const { useClaimedCharacterLoadoutsQuery } = charactersApi;
